"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function Error({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
      <h1 className="text-2xl font-bold">Etwas ist schiefgelaufen</h1>
      <p className="mt-2 text-muted-foreground">Ein unerwarteter Fehler ist aufgetreten.</p>
      <Button className="mt-6" onClick={reset}>Erneut versuchen</Button>
    </div>
  );
}
